import { useState, useEffect } from "react";
import "@/App.css";
import { content } from "@/data/content";
import { useLenis } from "@/hooks/useLenis";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { EditorialMarquee } from "@/components/Marquee";
import { Chapter } from "@/components/Chapter";
import { Gallery } from "@/components/Gallery";
import { Voices } from "@/components/Voices";
import { Faq } from "@/components/Faq";
import { Booking } from "@/components/Booking";
import { StatsRibbon } from "@/components/StatsRibbon";
import { Footer } from "@/components/Footer";

function App() {
  const [lang, setLang] = useState("fr");
  const t = content[lang];
  useLenis();

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  return (
    <div className="App bg-[#FAFAF7]">
      <div className="grain-overlay" aria-hidden="true" />
      <Header lang={lang} setLang={setLang} t={t} />
      <main>
        <Hero t={t} />
        <EditorialMarquee words={t.marquee} />
        {t.chapters.map((chapter, i) => (
          <Chapter
            key={`${lang}-${chapter.num}`}
            chapter={chapter}
            index={i}
            chaptersLabel={t.chaptersLabel}
          />
        ))}
        <Gallery lang={lang} />
        <Voices title={t.voicesTitle} voices={t.voices} reviewsCta={t.reviewsCta} />
        <Faq title={t.faqTitle} items={t.faq} />
        <Booking b={t.booking} />
      </main>
      <Footer f={t.footer} />
      <StatsRibbon stats={t.hero.stats} />
    </div>
  );
}

export default App;
